import { Container } from "reactstrap";

// /api landing — the public API isn't self-serve yet, so point people at the team.
const ApiInfo = () => (
  <Container className="py-5 text-center">
    <h2 style={{ fontWeight: 700 }}>DejaChart API</h2>
    <p className="text-muted" style={{ maxWidth: 560, margin: "12px auto 28px" }}>
      Interested in programmatic access to DejaChart&apos;s signals, pattern data, and
      historical analogs? Reach out to the team and we&apos;ll get you set up.
    </p>
    <p style={{ fontSize: 16 }}>
      Contact the team at{" "}
      <a href="mailto:contact@dejachart.com?subject=DejaChart%20API">contact@dejachart.com</a>.
    </p>
  </Container>
);

export default ApiInfo;
